import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * A tiny "Tapable-like" hook implementation.
 *
 * Design goals:
 * - Zero dependencies
 * - Browser-friendly
 * - Familiar API surface (tap/call, tapPromise/promise)
 */

/**
 * SyncHook - runs taps synchronously in registration order.
 */
export class SyncHook {
  constructor() {
    _defineProperty(this, "taps", []);
  }
  tap(name, fn) {
    var tap = {
      name,
      fn
    };
    this.taps.push(tap);
    return () => {
      var idx = this.taps.indexOf(tap);
      if (idx >= 0) this.taps.splice(idx, 1);
    };
  }
  call(...args) {
    var _iterator = _createForOfIteratorHelper(this.taps),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        t.fn(...args);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

/**
 * AsyncSeriesHook - runs taps in series, awaiting each.
 */
export class AsyncSeriesHook {
  constructor() {
    _defineProperty(this, "taps", []);
  }
  tapPromise(name, fn) {
    var tap = {
      name,
      fn
    };
    this.taps.push(tap);
    return () => {
      var idx = this.taps.indexOf(tap);
      if (idx >= 0) this.taps.splice(idx, 1);
    };
  }
  tap(name, fn) {
    return this.tapPromise(name, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(...args) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return fn(...args);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  }
  promise(...args) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _iterator2, _step2, t, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _iterator2 = _createForOfIteratorHelper(_this.taps);
            _context2.prev = 1;
            _iterator2.s();
          case 2:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 4;
              break;
            }
            t = _step2.value;
            _context2.next = 3;
            return t.fn(...args);
          case 3:
            _context2.next = 2;
            break;
          case 4:
            _context2.next = 6;
            break;
          case 5:
            _context2.prev = 5;
            _t = _context2["catch"](1);
            _iterator2.e(_t);
          case 6:
            _context2.prev = 6;
            _iterator2.f();
            return _context2.finish(6);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 5, 6, 7]]);
    }))();
  }
}